import React from "react";
import Box from "@mui/material/Box";
import Button from "../Button";
import Typography from "@mui/material/Typography";

//SVG ICONS AND IMAGES
import photo_banner from "../../assets/img/photo_banner.png";

import styles from "./styles";

const Hero = () => {
  return (
    <Box sx={styles.hero}>
      <Box sx={styles.wrapper}>
        <Box sx={{ textAlign: "left" }}>
          <Typography variant="h2">Unleash Your Business Potential</Typography>
          <Typography variant="body1" sx={styles.text}>
            Transform your business with CloudCodeBase's innovative cloud
            solutions. Experience unparalleled agility and scalability tailored
            just for you.
          </Typography>
          <Button>join us</Button>
        </Box>
        <Box component="img" src={photo_banner} sx={styles.photo} />
      </Box>
    </Box>
  );
};

export default Hero;
